import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';

const template = styled.div`
  ${({ displayState }) => css`
    padding: 25px;
    border: 1px solid #E3E3E3;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    width: 306px;
    min-height: 105px;
    position: relative;
    
    span > span {
      display: none;
    }

    &:hover {
      span > span {
        display: ${displayState?.preview ? 'none' : 'flex'};
      }
    }
  `}
`;

export default Wrapper(template);